import React, { useEffect } from 'react';
import { useInvokeApi } from '../../utils/useInvokeApi';
import { useParams } from 'react-router';
import LoadingBar from 'theme/components/LoadingBar';
import ErrorPage from './ErrorPage';
import View from './view';

type SignupActivationResponse = {
    givingPartnerType: 'church' | 'nonprofit';
    email: string;
};

type SignupActivationPayload = {
    code: string;
};

type RouteParams = {
    token: string;
};

const Activate = () => {
    const [response, makeRequest] =
        useInvokeApi<
            SignupActivationResponse,
            SignupActivationPayload,
            SignupActivationResponse
        >();
    const { token } = useParams<RouteParams>() as RouteParams;

    useEffect(() => {
        makeRequest('POST', '/signup/activation', {
            code: token,
        });
    }, [token, makeRequest]);

    if (response.type === 'REQUEST_INIT' || response.type === 'REQUEST_START')
        return <LoadingBar show />;

    if (response.type === 'REQUEST_ERROR') {
        const email = response.error.response?.data?.email || '';
        return (
            <ErrorPage code={response.error.response?.status} email={email} />
        );
    }

    return <View />;
};

export default Activate;
